import { render, staticRenderFns } from "./Advertising2Adverts.vue?vue&type=template&id=4c8cdb62&scoped=true"
import script from "./Advertising2Adverts.vue?vue&type=script&lang=js"
export * from "./Advertising2Adverts.vue?vue&type=script&lang=js"
import style0 from "./Advertising2Adverts.vue?vue&type=style&index=0&id=4c8cdb62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8cdb62",
  null
  
)

export default component.exports